import { useEffect } from "react"
import propTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { useMutation } from "@tanstack/react-query"

import { createPrice } from "services/prices"
import PriceForm from "./PriceForm"

const CreateModalForm = ({ isOpen, toggle, setShowAlertSuccess, setMsgSuccess }) => {
  const { isLoading, isError, error, isSuccess, mutateAsync } = useMutation(createPrice)

  const submit = async (data) => {
    await mutateAsync(data)
  }

  useEffect(() => {
    if (isSuccess) {
      setMsgSuccess("Precio creado satisfactoriamente")
      setShowAlertSuccess(true)
      toggle()
    }
  }, [isSuccess])

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Agregar precio
      </ModalHeader>
      <ModalBody>
        <PriceForm
          isCreate={true}
          submit={submit}
          toggle={toggle}
          isLoadingSubmit={isLoading}
          isError={isError}
          error={error}
        />
      </ModalBody>
    </Modal>
  )
}

CreateModalForm.propTypes = {
  isOpen: propTypes.any,
  toggle: propTypes.func,
  setShowAlertSuccess: propTypes.func,
  setMsgSuccess: propTypes.func,
}

export default CreateModalForm
